var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"daysAgo"},[_vm._v(_vm._s(_vm.displayBox.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }